export default __webpack_public_path__ + "static/media/gift-4.afa1c30d.svg";